export default __webpack_public_path__ + "static/media/jan-sendereks.1b78f22b.jpg";